import { Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { decrypt, formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { useSearchParams } from "react-router-dom";
import { UserDeleteOutlined } from "@ant-design/icons";

function HotelStaffResponseTime() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels, kioskSelection } =
        useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [search] = useSearchParams();
    const hotel_id = decrypt(`${search.get("id").replace("plus", "+")}`);

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "avg_response_total_time",
    });

    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids: [hotel_id],
        all_selected: false,
        call_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: staffResTimeStatus,
        data: staffResTimeRes,
        refetch: getStaffResTime,
    } = useQuery(
        "/hotel-staff-avg-response-time",
        async () => {
            return await HTTP(
                "/dashboard/getNewCallsAvgResponseTimeStaffWiseDetails",
                { ...formData },
            );
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        getStaffResTime();
    }, []);

    useEffect(() => {
        getStaffResTime();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            call_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (staffResTimeStatus === "success") {
            const { data: tableData, total } = staffResTimeRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [staffResTimeStatus, staffResTimeRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        console.log(columnKey);
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    const column = [
        {
            title: "Staff",
            render: (_, record) => (
                <div style={{ display: "flex", alignItems: "baseline" }}>
                    <p className="margin-right-5">
                        {record?.first_name !== "" && record?.last_name !== ""
                            ? `${record.first_name} ${record.last_name}`
                            : "-"}
                    </p>
                    {record?.is_deleted ? <UserDeleteOutlined /> : ""}
                </div>
            ),
            dataIndex: "first_name",
        },
        {
            title: "Average Response Time",
            dataIndex: "avg_response_total_time",
            key: "avg_response_total_time",
            render: (value) => (value !== "" ? value : "-"),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "avg_response_total_time"
                    ? sortedInfo.order
                    : null,
        },
    ];

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({
            ...formData,
            start_date,
            page: 0,
            end_date,
        });
    }, [selectedDates]);

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                {staffResTimeStatus !== "loading" &&
                staffResTimeStatus !== "idle" ? (
                    <CustomTable
                        columns={column}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        currentPage={formData.page + 1}
                        handleTableChange={handleTableChange}
                        className="HotelStaffTable"
                        rowKey="id"
                    />
                ) : (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                )}
            </Card>
        </Card>
    );
}

export { HotelStaffResponseTime };
